import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getAdminInitialWorkCalendarDataForProject = async (
  projectId,
  activeEmployerInfo
) => {
  const apiPath = `workflow/init/admin-request/${projectId}/employee-and-project-data`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
